import React from "react";
import { LayerContextProvider, Modal, SlideFromTop, layers } from "@activecollab/components";
import PropTypes from "prop-types";
import ProjectsListSelectorContainer from "./ProjectsListSelectorContainer.jsx";

const ProjectsModal = ({ open, onClose, onChooseProject }) => {
  return (
    <LayerContextProvider value={{ zIndex: layers.skyscraper }}>
      <Modal
        open={open}
        onClose={onClose}
      >
        <SlideFromTop in={open}>
          <div
            className="tw-mx-auto tw-mb-8 tw-mt-32"
            style={{ width: "350px" }}
          >
            <ProjectsListSelectorContainer onChooseProject={onChooseProject} />
          </div>
        </SlideFromTop>
      </Modal>
    </LayerContextProvider>
  );
};

ProjectsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onChooseProject: PropTypes.func,
  className: PropTypes.string,
};
ProjectsModal.defaultProps = {
  open: false,
  onClose: () => null,
  onChooseProject: () => null,
};

export default ProjectsModal;
